// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/metalog/app/css/app.css
// module id = 659
// module chunks = 0